import angular from 'angular';

import { svgUpload } from './svg.upload.directive';
import { SvgUpload } from './svg.upload.resource';

export default angular
  .module('svg.upload', [
    // leave it as string because of recursive dependencies
    'ppn.public',
  ])
  .factory('SvgUpload', SvgUpload)
  .directive('svgUpload', svgUpload);
